// @flow
import beer from './beer'
import specialPacks from './specialPacks'
import glassware from './glassware'

export default {
  beer,
  specialPacks,
  glassware
}
